"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIgtName = exports.igtNameMap = void 0;
exports.igtNameMap = {
    table: 'Table',
    keyboard: 'Keyboard',
    'aria-modal': 'Modal Dialog',
    'interactive-elements': 'Interactive Elements',
    structure: 'Structure',
    'page-info': 'Page Information',
    'buttons-and-links': 'Buttons and Links',
    lists: 'Lists',
    images: 'Images',
    headings: 'Headings',
    forms: 'Forms'
};
const getIgtName = (igt) => (igt ? exports.igtNameMap[igt] : '');
exports.getIgtName = getIgtName;
exports.default = exports.igtNameMap;
//# sourceMappingURL=igt-name-map.js.map